import { render, staticRenderFns } from "./PreviewDemand.vue?vue&type=template&id=6405be38&scoped=true&"
import script from "./PreviewDemand.vue?vue&type=script&lang=js&"
export * from "./PreviewDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405be38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VDivider,VFlex,VIcon,VLayout,VList,VListItem,VMenu})
